// extracted by mini-css-extract-plugin
export default {"layout":"zdBYS1","title":"Ot5Ryy","hide":"p60p6Y","description":"fPiV4E","titleWrap":"fRJ30I","headingWrap":"VdN29m"};